import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/marketing/diagram.png'


const _withScopeId = n => (_pushScopeId("data-v-6cb84052"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "install-agent" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "glow" }, null, -1))
const _hoisted_5 = { class: "front" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "content regular" }
const _hoisted_8 = { class: "scroll" }
const _hoisted_9 = { class: "explain" }
const _hoisted_10 = { class: "header bold" }
const _hoisted_11 = { class: "description" }
const _hoisted_12 = { class: "line1" }
const _hoisted_13 = { class: "hostname" }
const _hoisted_14 = { class: "join-grid" }
const _hoisted_15 = { class: "bold" }
const _hoisted_16 = { class: "helper" }
const _hoisted_17 = { class: "as-a bold" }
const _hoisted_18 = { class: "description" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = { class: "initiator" }
const _hoisted_21 = { class: "as-a bold" }
const _hoisted_22 = { class: "description" }
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "join" }
const _hoisted_25 = { class: "thank bold" }
const _hoisted_26 = {
  "data-testid": "incredibuild-site",
  class: "site",
  target: "_blank",
  href: "https://www.incredibuild.com/"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "diagram",
  src: _imports_0,
  alt: "diagram"
}, null, -1))

import { computed, watch } from 'vue';
import logo from '@/assets/images/marketing/logo.svg';
import { useLicense_LicenseKeyQuery, useSettings_Telemetry_EnabledQuery, useSystemInfoQuery } from '@/graphql/codegen/generated/graphql';
import { useMatomo } from '@/services/matomo/matomo.service';
import { MatomoCategories, MatomoExternalLinkActions } from '@/services/matomo/matomo.const';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'install-agent',
  setup(__props) {

const p = useSystemInfoQuery();
const route = useRoute();
const matomo = useMatomo();
const GQL_isTelemetryEnabled = useSettings_Telemetry_EnabledQuery();
const GQL_licenseKey = useLicense_LicenseKeyQuery();
const hostname = computed(() => p?.result?.value?.systemInfo?.hostname);
const installUrl = computed(() =>
  process.env.NODE_ENV === 'production'
    ? `${window.location.origin}/${process.env.VUE_APP_DOWNLOAD_INSTALL_PATHNAME}`
    : `${process.env.VUE_APP_IB_MANAGER_PROTOCOL}//${process.env.VUE_APP_IB_MANAGER_HOSTNAME}:${process.env.VUE_APP_IB_MANAGER_PORT}/${process.env.VUE_APP_DOWNLOAD_INSTALL_PATHNAME}`,
);

const licenseKey = computed(() => GQL_licenseKey?.result?.value?.license_licenseKey);
const isTelemetryEnabled = computed(() => GQL_isTelemetryEnabled?.result?.value?.settings_telemetry_enabled);

const initiateMatomo = (userId: string) => {
  matomo?.start({ userId });
  if (route.name?.toString()) {
    matomo?.trackPageView({
      documentTitle: route.name?.toString(),
      href: route.path,
    });
  }
};

const sendMatomoEventForButton = () => {
  matomo?.trackEvent({
    category: MatomoCategories.InstallAgent,
    action: MatomoExternalLinkActions.Click,
    name: 'downloadInstallerButton',
  });
};

watch(
  [isTelemetryEnabled, licenseKey],
  () => {
    if (!isTelemetryEnabled.value || !licenseKey.value) return;
    const shouldActive = isTelemetryEnabled.value && licenseKey.value;
    if (!matomo?.isInstanceStarted.value && shouldActive) initiateMatomo(licenseKey.value as string);
    else if (shouldActive) matomo?.start();
    else matomo?.stop();
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: _unref(logo),
            alt: "logo"
          }, null, 8, _hoisted_6)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('installAgent.header')), 1),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(hostname)), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('installAgent.description')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('installAgent.joinGrid')), 1),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('installAgent.helper.title')), 1),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('installAgent.helper.line1')) + " ", 1),
                    _hoisted_19,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('installAgent.helper.line2')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('installAgent.initiator.title')), 1),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('installAgent.initiator.line')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "download",
              onClick: sendMatomoEventForButton
            }, [
              _createElementVNode("a", {
                "data-testid": "download-installer",
                target: "_blank",
                class: "bold",
                href: _unref(installUrl)
              }, _toDisplayString(_ctx.$t('installAgent.downloadButton')), 9, _hoisted_23),
              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('installAgent.buttonDescription')), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('installAgent.thankYou1')), 1),
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('installAgent.thankYou2')) + " ", 1),
                _createElementVNode("a", _hoisted_26, _toDisplayString(_ctx.$t('installAgent.site')), 1)
              ])
            ])
          ])
        ]),
        _hoisted_27
      ])
    ])
  ]))
}
}

})